import { Textarea, TextareaProps } from "@chakra-ui/react";
import React, { memo } from "react";

interface Props extends TextareaProps {}

export const UiTextarea = memo(({ ...rest }: Props) => <Textarea {...rest} />);
